export default {
    "id": "clhp4o18y00000vmcxqa3ocy8",
    "email": "me@adnan.io",
    "roles": ["ADMIN"],
    "systemRoles": [
        { "id": 1, "name": "SuperAdmin", "level": 4 }
    ],
    "firstName": null,
    "lastName": null,
    "allowMultiple": false,
    "carts": [],
    "tradeProfile": null,
    "yearsInvited": null,
    "participant": null
};